module.exports = __webpack_public_path__ + "media/images/default/lp_about_seller-3e14e95d83457b9ef5be6306d92e6943.svg";